import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from '../../core/Loading';
import ChannelShare from '../../views/Audiences/channelShare';

import { setDataDailyShare } from '../../../actions';

class AudiencesHomeWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      onErrorLoadData: false,
      dataDailyShare: null
    };
  }

  componentDidMount() {
    const { setDataDailyShareHandler } = this.props;

    setDataDailyShareHandler()
      .then(data => {
        this.setState({
          dataDailyShare: data
        });
      })
      .catch(() => {
        this.setState({
          onErrorLoadData: true
        });
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  getRender = () => {
    const { loading, dataDailyShare, onErrorLoadData } = this.state;
    if (loading) {
      return <Loading size="m" />;
    }
    if (onErrorLoadData) {
      return (
        <p>Lo sentimos, pero no tenemos datos para la fecha seleccionada</p>
      );
    }
    return <ChannelShare data={dataDailyShare} />;
  };

  render() {
    return this.getRender();
  }
}

const mapStateToProps = state => ({
  dataDailyShare: state.audiences.dataDailyShare
});

const mapDispatchToProps = dispatch => ({
  setDataDailyShareHandler: () => setDataDailyShare(dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudiencesHomeWrapper);
